import React, { useEffect } from 'react';
import { Button, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';
import ExternalLink from '../../shared/components/ExternalLink';
import economicGoImg from './DK_EC_450x450_e-conomic_demoflow-image.png';
import { t } from '../../shared/components/l10n/l10n';
import track from '../../shared/util/utilities/mixpanel';

interface Props {
    onSkip: () => void;
    children: string | JSX.Element;
}

export default function StepEconomicGo({ onSkip, children }: Props) {
    useEffect(() => {
        track('economic-go', 'view');
    }, []);
    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__success text-center">
                {children}
                <h2>
                    <Trans>Get e-conomic and bookkeeping from an accountant in one package</Trans>
                </h2>
                <p>
                    <Trans>
                        For a fixed monthly fee you can now get the full e-conomic package plus an accountant/bookkeeper who takes
                        care of your bookkeeping. Tell us a bit about your business and get a free meeting with an accountant who
                        understands your industry.
                    </Trans>
                    <span>&nbsp;</span>
                    <ExternalLink href="https://www.e-conomic.dk/support/artikler/giv-en-administrator-adgang-til-din-aftale">
                        <Trans>Read more here</Trans>
                    </ExternalLink>
                </p>
                <img src={economicGoImg} alt="" className="w-48" />
                <div className="columns">
                    <div className="onboarding__navigation-buttons">
                        <div className="onboarding__skip-step">
                            <Button
                                appearance="discrete"
                                onClick={() => {
                                    track('economic-go', 'reminder');
                                    onSkip();
                                }}>
                                <Trans>Remind me later</Trans>
                            </Button>
                        </div>
                        <Group>
                            <Button
                                appearance="default"
                                onClick={() => {
                                    track('economic-go', 'skip');
                                    onSkip();
                                }}>{t`ONBOARDING_GETTINGSTARTED_SKIP`}</Button>
                            <Button
                                appearance="primary"
                                href="https://www.e-conomic.dk/revisorliste"
                                onClick={() => track('economic-go', 'book')}
                                target="_blank">
                                <Trans>Book a free consultation</Trans>
                            </Button>
                        </Group>
                    </div>
                </div>
            </div>
        </div>
    );
}
